package io.github.jangalinski.pages._2016._10._06

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initOsxIdeaExternalEditorPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2016/10/06/OsxIdeaExternalEditor.md", FrontMatterElement.Builder { addScalar("title", "Using external editors in IDEA/OSX"); addScalar("subtitle", "once and for all open your files in the system default editor"); addScalar("date", "2016-10-06"); }))
}

@Page("/2016/10/06/osx-idea-external-editor")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun OsxIdeaExternalEditorPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("When working with IDEA on OSX, some files can not be handled by the editor itself (for me, these are mostly camunda bpmn, cmmn and dmn files).")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Here's howto configure IDEA to open those files with the default system editor:")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("configure-osx-s-magic-open-command-as-external-tool") }) {
        org.jetbrains.compose.web.dom.Text("configure OSX's magic ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("open")
        }
        org.jetbrains.compose.web.dom.Text(" command as external tool")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/img/2016-10-07-idea-external-tools-1.png", "External Tool")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("add-a-keymap-shortcut-to-the-new-external-command") }) {
        org.jetbrains.compose.web.dom.Text("add a keymap shortcut to the new external command")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.graphics.Image("/img/2016-10-07-idea-external-tools-2.png", "Keymap shortcut")
    }
    org.jetbrains.compose.web.dom.H3(attrs = { id("done") }) {
        org.jetbrains.compose.web.dom.Text("Done ...")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("now press ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("cmd+shift+o")
        }
        org.jetbrains.compose.web.dom.Text(" after selecting the file in the project tree.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Thanks to Martin Schimack who show me this trick a while ago ... just needed it again.")
    }
}
